import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

import {
  BiGridAlt,
  BiWifi,
  BiCube,
  BiTransfer,
  BiLockAlt,
  BiLayer,
  BiCheckShield,
} from "react-icons/bi";

const Home1 = () => {
  const { isLoggedIn } = useSelector((state) => {
    const { isLoggedIn } = state.userData;
    return { isLoggedIn };
  });

  return (
    <div>
      <div className="w-[1280px] mx-auto min-h-screen bg-white text-slate-900 font-sans relative overflow-hidden selection:bg-blue-100">
        <nav className="w-full flex items-center justify-between py-6 px-12 bg-white z-50 relative">
          <div className="flex items-center cursor-pointer">
            <img
              src="/img/new/logo/logo.png"
              alt="ATDP Logo"
              className="w-32 object-contain"
            />
          </div>

          <div className="flex items-center gap-4">
            {isLoggedIn ? (
              <Link
                to="/dashboard/home"
                className="px-8 py-2.5 text-base font-semibold text-white bg-blue-600 hover:bg-blue-700 rounded-full shadow-lg shadow-blue-600/20 transition-all"
              >
                Dashboard
              </Link>
            ) : (
              <>
                <Link
                  to="/signin"
                  className="px-8 py-2.5 text-base font-semibold text-blue-600 border border-gray-200 hover:border-gray-300 hover:bg-gray-50 rounded-full transition-colors"
                >
                  Log in
                </Link>
                <Link
                  to="/signup"
                  className="px-8 py-2.5 text-base font-semibold text-white bg-[#1a4bdf] hover:bg-blue-700 rounded-full shadow-lg shadow-blue-600/20 transition-all"
                >
                  Sign up
                </Link>
              </>
            )}
          </div>
        </nav>

        {/* --- Hero Section --- */}
        <main className="flex items-center px-12 pt-12 pb-24 relative">
          {/* Left Content */}
          <div className="w-[60%] pr-8 z-10">
            <h1 className="text-[4rem] font-semibold  tracking-tight leading-[1.1] text-slate-900 mb-6">
              A digital asset company built on{" "}
              <span className="text-[#1a4bdf]">blockchain technology</span>
            </h1>

            <p className="text-[1.35rem] text-slate-500 leading-relaxed max-w-xl mb-10">
              Providing structured access to digital asset solutions through
              secure, transparent, and professionally managed systems.
            </p>

            <div className="flex items-center gap-6">
              <Link
                to="/signup"
                className="flex items-center gap-3 px-8 py-4 bg-[#1a4bdf] hover:bg-blue-700 text-white text-lg font-semibold rounded-full shadow-xl shadow-blue-600/20 transition-all"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
                </svg>
                Start Trading &rarr;
              </Link>
              <Link
                to="/signup"
                className="flex items-center gap-3 px-8 py-4 bg-white text-[#1a4bdf] text-lg font-semibold border-2 border-blue-50 rounded-full shadow-sm hover:bg-blue-50 transition-all"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="16" y1="2" x2="16" y2="6"></line>
                  <line x1="8" y1="2" x2="8" y2="6"></line>
                  <line x1="3" y1="10" x2="21" y2="10"></line>
                </svg>
                Explore Plans &rarr;
              </Link>
            </div>
          </div>

          {/* Right Content - Hero Image */}
          <div className="w-[40%] relative rounded-full">
            <img
              src="/img/new/background/heroimage.jpeg"
              alt="Global Blockchain Network"
              className="w-full h-auto object-contain scale-110 translate-x-8 rounded-full"
            />
          </div>
        </main>

        {/* --- Dark Banner Section --- */}
        <section className="px-12 mb-10">
          <div className="w-full bg-[#01072B] rounded-[2rem] flex overflow-hidden relative shadow-2xl">
            {/* Banner Left Content */}
            <div className="w-[40%] p-14 z-10 flex flex-col justify-center">
              <h2 className="text-white text-4xl font-semibold leading-tight mb-4">
                The Future of
                <br />
                Digital Assets
              </h2>
              <p className="text-blue-100/80 text-lg leading-relaxed mb-10 w-full">
                Built on blockchain technology for security, transparency, and
                global accessibility.
              </p>

              <div className="space-y-5">
                <div className="flex items-center gap-4 text-white text-lg font-medium">
                  <div className="w-8 h-8 rounded-full bg-blue-600/20 flex items-center justify-center text-blue-400">
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.5"
                    >
                      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                      <polyline points="9 12 11 14 15 10"></polyline>
                    </svg>
                  </div>
                  Secure Transactions
                </div>
                <div className="flex items-center gap-4 text-white text-lg font-medium">
                  <div className="w-8 h-8 rounded-full bg-blue-600/20 flex items-center justify-center text-blue-400">
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.5"
                    >
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                      <circle cx="12" cy="12" r="3"></circle>
                    </svg>
                  </div>
                  Transparent Operations
                </div>
                <div className="flex items-center gap-4 text-white text-lg font-medium">
                  <div className="w-8 h-8 rounded-full bg-blue-600/20 flex items-center justify-center text-blue-400">
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.5"
                    >
                      <circle cx="12" cy="12" r="10"></circle>
                      <line x1="2" y1="12" x2="22" y2="12"></line>
                      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
                    </svg>
                  </div>
                  Global Accessibility
                </div>
              </div>
            </div>

            {/* Banner Right Content (3D Coins Placeholder) */}
            <div
              className="w-[60%] relative flex items-center justify-center bg-cover bg-center"
              style={{
                backgroundImage: "url(/img/new/background/digitalasset.jpeg)",
              }}
            ></div>
          </div>
        </section>

        {/* --- Bottom Feature Cards Grid --- */}
        <section className="px-12 pb-24">
          <div className="grid grid-cols-4 gap-6">
            {/* Card 1 */}
            <div className="bg-white rounded-3xl p-8 flex flex-col items-center text-center border border-gray-100 shadow-[0_8px_30px_rgb(0,0,0,0.04)]">
              <div className="w-16 h-16 rounded-full bg-blue-50 flex items-center justify-center text-[#1a4bdf] mb-6">
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                  <line x1="12" y1="8" x2="12" y2="12"></line>
                  <line x1="12" y1="16" x2="12.01" y2="16"></line>
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-slate-900 mb-3">
                Secure
              </h3>
              <p className="text-slate-500 font-medium leading-relaxed">
                Bank-level security to protect your digital assets.
              </p>
              <div className="w-8 h-1 bg-[#1a4bdf] rounded-full mt-6"></div>
            </div>

            {/* Card 2 */}
            <div className="bg-white rounded-3xl p-8 flex flex-col items-center text-center border border-gray-100 shadow-[0_8px_30px_rgb(0,0,0,0.04)]">
              <div className="w-16 h-16 rounded-full bg-blue-50 flex items-center justify-center text-[#1a4bdf] mb-6">
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                  <circle cx="12" cy="12" r="3"></circle>
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-slate-900 mb-3">
                Transparent
              </h3>
              <p className="text-slate-500 font-medium leading-relaxed">
                Clear processes and real-time visibility.
              </p>
              <div className="w-8 h-1 bg-[#1a4bdf] rounded-full mt-6"></div>
            </div>

            {/* Card 3 */}
            <div className="bg-white rounded-3xl p-8 flex flex-col items-center text-center border border-gray-100 shadow-[0_8px_30px_rgb(0,0,0,0.04)]">
              <div className="w-16 h-16 rounded-full bg-blue-50 flex items-center justify-center text-[#1a4bdf] mb-6">
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <circle cx="12" cy="8" r="7"></circle>
                  <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline>
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-slate-900 mb-3">
                Reliable
              </h3>
              <p className="text-slate-500 font-medium leading-relaxed">
                Professionally managed systems you can trust.
              </p>
              <div className="w-8 h-1 bg-[#1a4bdf] rounded-full mt-6"></div>
            </div>

            {/* Card 4 */}
            <div className="bg-white rounded-3xl p-8 flex flex-col items-center text-center border border-gray-100 shadow-[0_8px_30px_rgb(0,0,0,0.04)]">
              <div className="w-16 h-16 rounded-full bg-blue-50 flex items-center justify-center text-[#1a4bdf] mb-6">
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="2" y1="12" x2="22" y2="12"></line>
                  <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-slate-900 mb-3">
                Accessible
              </h3>
              <p className="text-slate-500 font-medium leading-relaxed">
                Digital asset solutions for everyone.
              </p>
              <div className="w-8 h-1 bg-[#1a4bdf] rounded-full mt-6"></div>
            </div>
          </div>
        </section>

        <section className="px-12 py-24">
          {/* Section Header */}
          <div className="mb-10">
            <div className="flex flex-col items-start gap-3 mb-4">
              <span className="text-[#1a4bdf] font-semibold tracking-widest uppercase text-sm">
                Quickly start trading
              </span>
              <div className="w-10 h-1 bg-[#1a4bdf]"></div>
            </div>
            <h2 className="text-[4rem] font-semibold font-head text-slate-900 leading-[1.1]">
              Get started in <span className="text-[#1a4bdf]">minutes</span>
            </h2>
          </div>

          {/* Dark Banner */}
          <div
            className="w-full rounded-[2rem] p-32 flex items-center justify-between mb-16 relative overflow-hidden shadow-2xl"
            style={{
              backgroundImage: "url('/img/new/background/clock.jpeg')",
              backgroundSize: "cover",
              backgroundPosition: "right",
            }}
          >
            <div className="w-1/2 z-10">
              <p className="text-white text-2xl font-medium leading-relaxed">
                Open an account today to access structured investment
                opportunities through a secure and professionally managed
                platform.
              </p>
            </div>
          </div>

          {/* Vertical Steps */}
          <div className="relative flex flex-col gap-6 pl-4 pr-12">
            {/* Vertical Dotted Line connecting the icons */}
            <div className="absolute left-[4.25rem] top-16 bottom-16 w-px border-l-2 border-dotted border-blue-200 -z-0"></div>

            {/* Step 01 */}
            <div className="relative z-10 bg-white rounded-3xl p-8 flex items-center shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-gray-100">
              <div className="w-24 h-24 bg-blue-50/80 rounded-[1.5rem] flex items-center justify-center shrink-0 mr-12 shadow-sm border border-blue-100">
                {/* User Icon */}
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#1a4bdf"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
              </div>
              <div className="flex-grow">
                <span className="block text-2xl text-[#1a4bdf] font-semibold mb-1">
                  01
                </span>
                <h3 className="text-2xl font-semibold text-slate-900 mb-2">
                  Open Account
                </h3>
                <p className="text-slate-500 font-medium text-lg leading-relaxed max-w-xl">
                  Create your account in just a few simple steps and gain access
                  to the Africa's Trusted Digital Platform platform.
                </p>
              </div>
              <div className="w-12 h-12 bg-blue-50/80 text-[#1a4bdf] rounded-full flex items-center justify-center shrink-0 cursor-pointer hover:bg-[#1a4bdf] hover:text-white transition-all">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                  <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
              </div>
            </div>

            {/* Step 02 */}
            <div className="relative z-10 bg-white rounded-3xl p-8 flex items-center shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-gray-100">
              <div className="w-24 h-24 bg-blue-50/80 rounded-[1.5rem] flex items-center justify-center shrink-0 mr-12 shadow-sm border border-blue-100">
                {/* Wallet Icon */}
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#1a4bdf"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M21 12V7H5a2 2 0 0 1 0-4h14v4"></path>
                  <path d="M3 5v14a2 2 0 0 0 2 2h16v-5"></path>
                  <path d="M18 12a2 2 0 0 0 0 4h4v-4Z"></path>
                </svg>
              </div>
              <div className="flex-grow">
                <span className="block text-2xl text-[#1a4bdf] font-semibold mb-1">
                  02
                </span>
                <h3 className="text-2xl font-semibold text-slate-900 mb-2">
                  Fund your account
                </h3>
                <p className="text-slate-500 font-medium text-lg leading-relaxed max-w-xl">
                  Deposit funds securely via supported payment methods to
                  activate your account and prepare for investment.
                </p>
              </div>
              <div className="w-12 h-12 bg-blue-50/80 text-[#1a4bdf] rounded-full flex items-center justify-center shrink-0 cursor-pointer hover:bg-[#1a4bdf] hover:text-white transition-all">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                  <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
              </div>
            </div>

            {/* Step 03 */}
            <div className="relative z-10 bg-white rounded-3xl p-8 flex items-center shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-gray-100">
              <div className="w-24 h-24 bg-blue-50/80 rounded-[1.5rem] flex items-center justify-center shrink-0 mr-12 shadow-sm border border-blue-100">
                {/* Chart/Trading Icon */}
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#1a4bdf"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
                </svg>
              </div>
              <div className="flex-grow">
                <span className="block text-2xl text-[#1a4bdf] font-semibold mb-1">
                  03
                </span>
                <h3 className="text-2xl font-semibold text-slate-900 mb-2">
                  Start trading
                </h3>
                <p className="text-slate-500 font-medium text-lg leading-relaxed max-w-xl">
                  Explore investment plans, monitor performance in real time,
                  and grow your portfolio with confidence.
                </p>
              </div>
              <div className="w-12 h-12 bg-blue-50/80 text-[#1a4bdf] rounded-full flex items-center justify-center shrink-0 cursor-pointer hover:bg-[#1a4bdf] hover:text-white transition-all">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                  <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
              </div>
            </div>
          </div>
        </section>

        {/* --- Trusted & Secure Section --- */}
        <section className="px-12 py-24 bg-[#f8fafe]">
          <div className="flex justify-between items-center mb-24">
            {/* Left Text Column */}
            <div className="w-[55%] pr-16">
              <div className="flex flex-col items-start gap-3 mb-6">
                <span className="text-[#1a4bdf] font-semibold tracking-widest uppercase text-sm">
                  Trusted & Secure
                </span>
                <div className="w-10 h-1 bg-[#1a4bdf]"></div>
              </div>

              <h2 className="text-[3.5rem] font-semibold text-slate-900 leading-[1.15] mb-8">
                High standards across custody,{" "}
                <span className="text-[#1a4bdf]">security</span>, and compliance
              </h2>

              <p className="text-xl text-slate-500 font-medium leading-relaxed">
                Africa's Trusted Digital Platform is built with a strong focus
                on secure asset handling, platform protection, and responsible
                operational practices. Our systems and processes are designed to
                support a secure environment for managing accounts and
                participating in digital asset activities.
              </p>
            </div>

            {/* Right Image Column */}
            <div className="w-[45%] relative flex justify-center">
              <img
                src="/img/new/background/shield.jpeg"
                alt="Secure Shield"
                className="w-full max-w-lg object-contain rounded-full scale-110"
              />
            </div>
          </div>

          {/* Bottom Feature Grid (4 Columns) */}
          <div className="grid grid-cols-4 gap-8 pt-8">
            {/* Item 1 */}
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-[#1a4bdf] shrink-0">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                  <polyline points="9 12 11 14 15 10"></polyline>
                </svg>
              </div>
              <div>
                <h4 className="text-lg font-semibold text-slate-900 mb-1">
                  Secure
                </h4>
                <p className="text-sm text-slate-500 font-medium leading-relaxed">
                  Bank-level security to protect assets
                </p>
              </div>
            </div>

            {/* Item 2 */}
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-[#1a4bdf] shrink-0">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                  <circle cx="12" cy="12" r="3"></circle>
                </svg>
              </div>
              <div>
                <h4 className="text-lg font-semibold text-slate-900 mb-1">
                  Transparent
                </h4>
                <p className="text-sm text-slate-500 font-medium leading-relaxed">
                  Clear processes and real-time visibility
                </p>
              </div>
            </div>

            {/* Item 3 */}
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-[#1a4bdf] shrink-0">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <circle cx="12" cy="8" r="7"></circle>
                  <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline>
                </svg>
              </div>
              <div>
                <h4 className="text-lg font-semibold text-slate-900 mb-1">
                  Reliable
                </h4>
                <p className="text-sm text-slate-500 font-medium leading-relaxed">
                  Professionally managed systems
                </p>
              </div>
            </div>

            {/* Item 4 */}
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-[#1a4bdf] shrink-0">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="2" y1="12" x2="22" y2="12"></line>
                  <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
                </svg>
              </div>
              <div>
                <h4 className="text-lg font-semibold text-slate-900 mb-1">
                  Compliant
                </h4>
                <p className="text-sm text-slate-500 font-medium leading-relaxed">
                  Adhering to industry standards and policies
                </p>
              </div>
            </div>
          </div>
        </section>

        <div className="pt-24 pb-12 flex flex-col items-center text-center">
          {/* Sparkle Icon */}
          <div className="text-[#1a4bdf] mb-6">
            <svg
              width="64"
              height="64"
              viewBox="0 0 64 64"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M32 0L36 24L60 28L36 32L32 56L28 32L4 28L28 24L32 0Z" />
              <path
                d="M12 40L14 48L22 50L14 52L12 60L10 52L2 50L10 48L12 40Z"
                className="opacity-70"
              />
              <path
                d="M52 40L54 48L62 50L54 52L52 60L50 52L42 50L50 48L52 40Z"
                className="opacity-70"
              />
            </svg>
          </div>

          <h2 className="text-[3.5rem] font-semibold text-slate-900 leading-[1.15]">
            Earn with Africa's
            <br />
            Trusted Digital Platform
          </h2>
        </div>

        {/* --- Stacked Cards Container --- */}
        <div className="max-w-4xl mx-auto flex flex-col gap-6 px-12">
          {/* Referral Commissions Card */}
          <div className="bg-white rounded-3xl p-10 flex items-center gap-10 shadow-[0_4px_20px_rgb(0,0,0,0.02)] border border-gray-100">
            <div className="w-24 h-24 bg-[#f0f4ff] rounded-full flex items-center justify-center shrink-0 text-[#1a4bdf]">
              <svg
                width="40"
                height="40"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
              </svg>
            </div>
            <div>
              <h3 className="text-2xl font-semibold text-slate-900 mb-3">
                Referral commissions
              </h3>
              <p className="text-slate-500 font-medium leading-relaxed text-lg">
                Earn rewards by introducing others to the Africa's Trusted
                Digital Platform platform. Receive commission incentives when
                referred users actively engage, with rewards structured to
                support long-term participation.
              </p>
            </div>
          </div>

          {/* Maker Rewards Card */}
          <div className="bg-white rounded-3xl p-10 flex items-center gap-10 shadow-[0_4px_20px_rgb(0,0,0,0.02)] border border-gray-100">
            <div className="w-24 h-24 bg-[#f0f4ff] rounded-full flex items-center justify-center shrink-0 text-[#1a4bdf]">
              <svg
                width="40"
                height="40"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
              </svg>
            </div>
            <div>
              <h3 className="text-2xl font-semibold text-slate-900 mb-3">
                Maker rewards
              </h3>
              <p className="text-slate-500 font-medium leading-relaxed text-lg">
                Participate in the market by providing liquidity to our order
                books. When your orders are matched and executed, you may earn
                maker based incentives as part of our liquidity support
                framework.
              </p>
            </div>
          </div>

          {/* CTA Card */}
          <div className="bg-white rounded-3xl p-12 mt-4 flex flex-col items-center text-center shadow-[0_4px_20px_rgb(0,0,0,0.02)] border border-gray-100 relative overflow-hidden">
            {/* Decorative wavy lines placeholder background */}
            <div
              className="absolute inset-0 opacity-10 pointer-events-none"
              style={{
                backgroundImage:
                  "radial-gradient(circle at 50% 150%, #1a4bdf 0%, transparent 60%)",
              }}
            ></div>

            <h3 className="text-4xl font-semibold text-slate-900 mb-8 z-10">
              Pro Trading, <span className="text-[#1a4bdf]">For Everyone.</span>
            </h3>

            <button className="px-10 py-4 bg-[#2563eb] hover:bg-blue-700 text-white text-xl font-semibold rounded-full shadow-lg shadow-blue-600/20 transition-all z-10">
              Get Started
            </button>
          </div>
        </div>

        {/* --- Ecosystem Section --- */}
        <div className="max-w-5xl mx-auto px-12 pt-24 pb-24 text-center">
          {/* Section Divider Title */}
          <div className="flex items-center justify-center gap-6 mb-6">
            <div className="h-px w-24 bg-gradient-to-r from-transparent to-gray-300"></div>
            <h3 className="text-2xl font-semibold text-slate-900">
              Our Ecosystem
            </h3>
            <div className="h-px w-24 bg-gradient-to-l from-transparent to-gray-300"></div>
          </div>

          <p className="text-lg text-slate-500 font-medium leading-relaxed max-w-4xl mx-auto mb-16">
            Africa's Trusted Digital Platform operates within a global digital
            asset ecosystem that includes leading investors, liquidity
            providers, and technology partners across the financial and
            blockchain industries.
          </p>

          {/* Logos Grid */}
          <div className="grid grid-cols-3 gap-y-12 items-center justify-items-center opacity-80 mix-blend-multiply grayscale hover:grayscale-0 transition-all duration-500">
            {/* Row 1 */}
            <div className="text-3xl font-serif font-semibold text-slate-800">
              Third Prime
            </div>
            <div className="text-4xl font-semibold tracking-tighter text-black">
              Raba
            </div>
            <div className="text-3xl font-semibold tracking-widest text-slate-700">
              GSR
            </div>

            {/* Row 2 */}
            <div className="text-3xl font-semibold text-[#0052FF] lowercase tracking-tight">
              coinbase
            </div>
            <div className="flex flex-col items-center">
              <span className="text-2xl font-serif text-slate-800 tracking-widest">
                MONTEGRAY
              </span>
              <span className="text-xs tracking-[0.3em] text-slate-500">
                CAPITAL
              </span>
            </div>
            <div className="text-4xl font-black text-slate-900">4Di</div>
          </div>

          {/* Bottom Logo centered */}
          <div className="mt-12 flex justify-center opacity-80 grayscale mix-blend-multiply">
            <span className="text-2xl tracking-[0.4em] font-medium text-slate-800">
              PANTERA
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home1;
